export function Mutation(target, key, descriptor) {
    var vuexModule = target.constructor;
    if (!vuexModule.__mutations) {
        vuexModule.__mutations = {};
    }
    if (descriptor.value) {
        vuexModule.__mutations[key] = descriptor.value;
    }
}
